import { ReporterErrorParams } from './types';

const reportErrorResolved = process.browser
  ? require('./client').reportErrorClient
  : require('./server').reportErrorServer;

export const reportError = (params: ReporterErrorParams): Promise<void> =>
  reportErrorResolved(params);
